import { Flex, Tooltip } from '@buffer-mono/popcorn'

import { ViewOnlyBadge } from '~publish/components/ViewOnlyBadge'

import styles from './ViewOnlyIndicator.module.css'

import type { JSX } from 'react'

const VIEW_ONLY_TOOLTIP =
  'To reply, like, and resolve comments in this channel, ask an admin to update your permissions.'

/**
 * The eye + "View only" badge shown at the bottom-right inside an expanded
 * view-only comment card — the same badge as the page header's view-only hint
 * (see ViewOnlyBadge). The full explanation lives in the tooltip. See EPD-998.
 */
export const ViewOnlyIndicator = (): JSX.Element => (
  <Flex justify="end" fullWidth className={styles.row}>
    <Tooltip content={VIEW_ONLY_TOOLTIP}>
      <ViewOnlyBadge tabIndex={0} />
    </Tooltip>
  </Flex>
)

ViewOnlyIndicator.displayName = 'ViewOnlyIndicator'
